import { computed, createApp, watch } from 'vue';
import UpgradeLoading from '@/components/orderDialog/UpgradeLoading.vue';
import UpgradeAlert from '@/components/orderDialog/UpgradeAlert.vue';
import store from '@/store';
import { useConfirm, useMessage } from '@/utils/confirm';

//更新蓋板畫面
let loadingDom;
const useUpgradeLoading = (status) => {
  const div = document.querySelector('#upgrade-loading');
  if (div) div.remove();
  if (status) {
    loadingDom = createApp(UpgradeLoading).mount(document.createElement('div'));
    document.body.appendChild(loadingDom.$el);
  }
};

//下載進度條
let progressDom;
const useDownloadProgress = (status) => {
  const div = document.querySelector('#progress-dialog');
  if (div) div.remove();
  if (status) {
    progressDom = createApp(UpgradeAlert).mount(document.createElement('div'));
    document.body.appendChild(progressDom.$el);
  }
};

//checkStatus api setinterval
let timer;
const setCheckSoftwareStatus = () => {
  store.dispatch('upgrade/checkSoftwareStatus');
  return setCheckSoftwareStatus;
};
const doSetCheckInterval = (time) => {
  timer && clearInterval(timer);
  timer = setInterval(setCheckSoftwareStatus(), time);
};
const clearCheckInterval = () => {
  clearInterval(timer);
};

//軟體更新按鈕處理不同狀態
const handleUpgradeStatus = (status) => {
  const getVersionText = computed(() => store.getters['upgrade/getVersionText']);
  switch (status) {
    case 0:
      useMessage('已更新至最新版本', `${getVersionText.value}目前尚無其他版本可供更新`, {
        confirmText: '我知道了',
        image: require('@/assets/images/icon-pass.png'),
      }).catch((e) => e);
      break;
    case 1:
      useMessage('下載安裝檔', `${getVersionText.value}目前已有新版檔案，是否在背景下載安裝檔？`, {
        confirmText: '下載',
        distinguishClose: true,
      })
        .then(async () => {
          await store.dispatch('upgrade/softwareDownload');
          useDownloadProgress(true);
        })
        .catch((e) => e);
      break;
    case 2:
      useDownloadProgress(true);
      break;
    case 3:
      useConfirm({
        title: '登出並更新',
        content: `${getVersionText.value}更新將耗時數分鐘，會登出並清空資料，是否立即更新？`,
        confirmText: '登出並更新',
        cancelText: '稍後再說',
      })
        .then(async () => {
          await store.dispatch('upgrade/softwareUpgrade');
          useUpgradeLoading(true);
          store.dispatch('system/doLogout');
        })
        .catch((e) => e);
      break;
    default:
      useMessage('伺服器狀態異常', `請洽客服處理或稍後再試`).catch((e) => e);
      break;
  }
};

//App.vue監聽不同狀態
const watchSoftwareStatus = () => {
  watch(
    () => store.getters['upgrade/getSoftwareStatus'],
    () => {
      //   console.log('watch', store.getters['upgrade/getSoftwareStatus']);
      switch (store.getters['upgrade/getSoftwareStatus']) {
        case -2:
          useUpgradeLoading(false);
          useDownloadProgress(false);
          useMessage('安裝異常', `請洽客服處理`).catch((e) => e);
          clearCheckInterval();
          break;
        case -1:
          useUpgradeLoading(false);
          useDownloadProgress(false);
          useMessage('下載狀態異常無法更新', `請洽客服處理或稍後再試`).catch((e) => e);
          clearCheckInterval();
          break;
        case 2:
          //檔案下載中
          doSetCheckInterval(30000);
          break;
        case 4:
          //軟體更新中
          //以下為異常狀態導致loading畫面沒開啟時的備案
          if (!document.querySelector('#upgrade-loading')) useUpgradeLoading(true);
          if (sessionStorage.getItem('session')) store.dispatch('system/doLogout');
          break;
        default:
          //其他狀態不需要setInterval api
          clearCheckInterval();
          break;
      }
    },
    { immediate: true }
  );
};

export {
  useUpgradeLoading,
  useDownloadProgress,
  handleUpgradeStatus,
  watchSoftwareStatus,
  doSetCheckInterval,
  clearCheckInterval,
};
